import React, { useState } from 'react';
import { AppstoreOutlined, GiftOutlined, BookOutlined, PictureOutlined, HomeOutlined, FileTextOutlined, MenuOutlined, MessageOutlined } from '@ant-design/icons';
import { Outlet, Link, useLocation } from 'react-router-dom'
import { Layout, Menu, theme } from 'antd';
import logo from '../../images/logo.jpeg'

const { Header, Sider, Content } = Layout;

const Index = () => {
    const [collapsed, setCollapsed] = useState(false);
    const { token: { colorBgContainer }, } = theme.useToken();
    const location = useLocation();

    // 判断当前是否为小程序模块路径
    const isMiniProgram = location.pathname.startsWith('/activity') 
        || location.pathname.startsWith('/benefit') 
        || location.pathname.startsWith('/dictionary')
        || location.pathname.startsWith('/news')
        || location.pathname.startsWith('/homepage')
        || location.pathname.startsWith('/banner')
        || location.pathname.startsWith('/bottomMenu')
        || location.pathname.startsWith('/smsTemplate');

    // 当前选中的子菜单 key
    const selectedKey = location.pathname;

    const sidebarItems = [
        {
            key: '/homepage',
            icon: <HomeOutlined />,
            label: <Link to='/homepage'>首页管理</Link>,
        },
        {
            key: 'home-sub',
            icon: <PictureOutlined />,
            label: '首页组件',
            children: [
                {
                    key: '/banner',
                    label: <Link to='/banner'>轮播图管理</Link>,
                },
                {
                    key: '/bottomMenu',
                    label: <Link to='/bottomMenu'>底部菜单管理</Link>,
                },
            ],
        },
        {
            key: '/activity',
            icon: <AppstoreOutlined />,
            label: <Link to='/activity'>活动管理</Link>,
        },
        {
            key: '/news',
            icon: <FileTextOutlined />,
            label: <Link to='/news'>资讯管理</Link>,
        },
        {
            key: '/benefit',
            icon: <GiftOutlined />,
            label: <Link to='/benefit'>权益管理</Link>,
        },
        {
            key: '/dictionary',
            icon: <BookOutlined />,
            label: <Link to='/dictionary'>字典管理</Link>,
        },
        {
            key: '/smsTemplate',
            icon: <MessageOutlined />,
            label: <Link to='/smsTemplate'>短信模板管理</Link>,
        },
    ];

    return (
        <Layout style={{ minHeight: '100vh' }}>
        <Header style={{ display: 'flex', alignItems: 'center' }}>
          <div className="demo-logo-vertical"><img src={logo}/> </div>
          <Menu 
            style={{marginLeft: 30}} 
            theme="dark" 
            mode="horizontal" 
            defaultSelectedKeys={['2']} 
            items={[
              {
                key: '1',
                label: <Link to='/activity'>小程序配置</Link>,
              },
              {
                key: '2',
                label: <Link to='/media/report'>线索报表</Link>,
              },
            ]} 
            />
        </Header>
        <Layout>
          <Sider
            width={200}
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            style={{
              background: colorBgContainer,
              display: isMiniProgram ? 'flex' : 'none',
            }}
            theme="light"
          >
            <Menu
              mode="inline"
              selectedKeys={[selectedKey]}
              style={{ height: '100%', borderRight: 0 }}
              items={sidebarItems}
            />
          </Sider>
          <Content
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
              background: colorBgContainer,
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    )
};

export default Index;